module.exports = __webpack_public_path__ + "img/bg.14d6a34f.png";